<template>
  <div>
    <vs-button
      @click="handleClick"
      :disabled="disabled"
      :class="btnClass"
      color="success"
      type="filled"
      icon-pack="feather"
      :icon="btnIcon"
      > {{ btnText || $t('add') }}
    </vs-button>
  </div>
</template>

<script>
export default {
  props:{
    disabled:{
      type:Boolean,
      default:false
    },
    btnClass:{
      type:String,
      default:'w-full'
    },
    btnText:{
      type:String,
      default:''
    },
    btnIcon:{
      type:String,
      default:'icon-plus'
    },
  },
  methods: {
    handleClick() {
      this.$emit('click')
    },
  },
}
</script>

<style>
</style>